export default __webpack_public_path__ + "static/media/block-7.82ffa823.jpg";